"use strict";
exports.__esModule = true;
var events_1 = require("../manifest/events");
exports.ActivitiesImageCarouselSeenEventManifestV1 = events_1.ActivitiesImageCarouselSeenEventManifestV1;
var events_2 = require("../manifest/events");
exports.ActivitiesOverviewSeenEventManifestV1 = events_2.ActivitiesOverviewSeenEventManifestV1;
var events_3 = require("../manifest/events");
exports.ActivitiesInclusionListSeenEventManifestV1 = events_3.ActivitiesInclusionListSeenEventManifestV1;
var events_4 = require("../manifest/events");
exports.ActivitiesDepartureReturnContainerSeenEventManifestV1 = events_4.ActivitiesDepartureReturnContainerSeenEventManifestV1;
var events_5 = require("../manifest/events");
exports.ActivitiesDepartureReturnInfoSeenEventManifestV1 = events_5.ActivitiesDepartureReturnInfoSeenEventManifestV1;
var events_6 = require("../manifest/events");
exports.ActivitiesWhatToExpectContainerSeenEventManifestV1 = events_6.ActivitiesWhatToExpectContainerSeenEventManifestV1;
var events_7 = require("../manifest/events");
exports.ActivitiesWhatToExpectInfoSeenEventManifestV1 = events_7.ActivitiesWhatToExpectInfoSeenEventManifestV1;
var events_8 = require("../manifest/events");
exports.ActivitiesCancellationContainerSeenEventManifestV1 = events_8.ActivitiesCancellationContainerSeenEventManifestV1;
var events_9 = require("../manifest/events");
exports.ActivitiesCancellationInfoSeenEventManifestV1 = events_9.ActivitiesCancellationInfoSeenEventManifestV1;
var events_10 = require("../manifest/events");
exports.ActivitiesAdditionalInfoContainerSeenEventManifestV1 = events_10.ActivitiesAdditionalInfoContainerSeenEventManifestV1;
var events_11 = require("../manifest/events");
exports.ActivitiesDetailsAdditionalInfoSeenEventManifestV1 = events_11.ActivitiesDetailsAdditionalInfoSeenEventManifestV1;
var events_12 = require("../manifest/events");
exports.ActivitiesPointSeenEventManifestV1 = events_12.ActivitiesPointSeenEventManifestV1;
var events_13 = require("../manifest/events");
exports.ActivitiesPriceSeenEventManifestV1 = events_13.ActivitiesPriceSeenEventManifestV1;
var events_14 = require("../manifest/events");
exports.ActivitiesSeeOptionButtonSeenEventManifestV1 = events_14.ActivitiesSeeOptionButtonSeenEventManifestV1;
var events_15 = require("../manifest/events");
exports.ActivitiesImageCarouselHoverEventManifestV1 = events_15.ActivitiesImageCarouselHoverEventManifestV1;
var events_16 = require("../manifest/events");
exports.ActivitiesImageCarouselClickEventManifestV1 = events_16.ActivitiesImageCarouselClickEventManifestV1;
var events_17 = require("../manifest/events");
exports.ActivitiesImageCarouselRevealEventManifestV1 = events_17.ActivitiesImageCarouselRevealEventManifestV1;
var events_18 = require("../manifest/events");
exports.ActivitiesOverviewHoverEventManifestV1 = events_18.ActivitiesOverviewHoverEventManifestV1;
var events_19 = require("../manifest/events");
exports.ActivitiesOverviewClickEventManifestV1 = events_19.ActivitiesOverviewClickEventManifestV1;
var events_20 = require("../manifest/events");
exports.ActivitiesOverviewRevealEventManifestV1 = events_20.ActivitiesOverviewRevealEventManifestV1;
var events_21 = require("../manifest/events");
exports.ActivitiesInclusionListHoverEventManifestV1 = events_21.ActivitiesInclusionListHoverEventManifestV1;
var events_22 = require("../manifest/events");
exports.ActivitiesInclusionListClickEventManifestV1 = events_22.ActivitiesInclusionListClickEventManifestV1;
var events_23 = require("../manifest/events");
exports.ActivitiesInclusionListRevealEventManifestV1 = events_23.ActivitiesInclusionListRevealEventManifestV1;
var events_24 = require("../manifest/events");
exports.ActivitiesDepartureReturnContainerClickEventManifestV1 = events_24.ActivitiesDepartureReturnContainerClickEventManifestV1;
var events_25 = require("../manifest/events");
exports.ActivitiesDepartureReturnContainerRevealEventManifestV1 = events_25.ActivitiesDepartureReturnContainerRevealEventManifestV1;
var events_26 = require("../manifest/events");
exports.ActivitiesDepartureReturnInfoRevealEventManifestV1 = events_26.ActivitiesDepartureReturnInfoRevealEventManifestV1;
var events_27 = require("../manifest/events");
exports.ActivitiesWhatToExpectContainerClickEventManifestV1 = events_27.ActivitiesWhatToExpectContainerClickEventManifestV1;
var events_28 = require("../manifest/events");
exports.ActivitiesWhatToExpectContainerRevealEventManifestV1 = events_28.ActivitiesWhatToExpectContainerRevealEventManifestV1;
var events_29 = require("../manifest/events");
exports.ActivitiesWhatToExpectInfoRevealEventManifestV1 = events_29.ActivitiesWhatToExpectInfoRevealEventManifestV1;
var events_30 = require("../manifest/events");
exports.ActivitiesCancellationContainerClickEventManifestV1 = events_30.ActivitiesCancellationContainerClickEventManifestV1;
var events_31 = require("../manifest/events");
exports.ActivitiesCancellationContainerRevealEventManifestV1 = events_31.ActivitiesCancellationContainerRevealEventManifestV1;
var events_32 = require("../manifest/events");
exports.ActivitiesCancellationInfoRevealEventManifestV1 = events_32.ActivitiesCancellationInfoRevealEventManifestV1;
var events_33 = require("../manifest/events");
exports.ActivitiesAdditionalInfoContainerClickEventManifestV1 = events_33.ActivitiesAdditionalInfoContainerClickEventManifestV1;
var events_34 = require("../manifest/events");
exports.ActivitiesAdditionalInfoContainerRevealEventManifestV1 = events_34.ActivitiesAdditionalInfoContainerRevealEventManifestV1;
var events_35 = require("../manifest/events");
exports.ActivitiesDetailsAdditionalInfoRevealEventManifestV1 = events_35.ActivitiesDetailsAdditionalInfoRevealEventManifestV1;
var events_36 = require("../manifest/events");
exports.ActivitiesPointHoverEventManifestV1 = events_36.ActivitiesPointHoverEventManifestV1;
var events_37 = require("../manifest/events");
exports.ActivitiesPointClickEventManifestV1 = events_37.ActivitiesPointClickEventManifestV1;
var events_38 = require("../manifest/events");
exports.ActivitiesPointRevealEventManifestV1 = events_38.ActivitiesPointRevealEventManifestV1;
var events_39 = require("../manifest/events");
exports.ActivitiesPriceHoverEventManifestV1 = events_39.ActivitiesPriceHoverEventManifestV1;
var events_40 = require("../manifest/events");
exports.ActivitiesPriceClickEventManifestV1 = events_40.ActivitiesPriceClickEventManifestV1;
var events_41 = require("../manifest/events");
exports.ActivitiesPriceRevealEventManifestV1 = events_41.ActivitiesPriceRevealEventManifestV1;
var events_42 = require("../manifest/events");
exports.ActivitiesSeeOptionButtonHoverEventManifestV1 = events_42.ActivitiesSeeOptionButtonHoverEventManifestV1;
var events_43 = require("../manifest/events");
exports.ActivitiesSeeOptionButtonClickEventManifestV1 = events_43.ActivitiesSeeOptionButtonClickEventManifestV1;
var events_44 = require("../manifest/events");
exports.ActivitiesSeeOptionButtonRevealEventManifestV1 = events_44.ActivitiesSeeOptionButtonRevealEventManifestV1;
exports.WebActivitiesDetailTabActivatedEventManifestV1 = {
    ids: {
        action_type: 'tab-activated',
        event_version: 1,
        page_type_id: 9102
    }
};
exports.WebActivitiesDetailVisitEventManifestV2 = {
    ids: {
        action_type: 'visit',
        event_version: 2,
        page_type_id: 9102
    }
};
exports.ActivitiesDetailsPageDesktopContextManifestV1 = {
    ids: {
        context_version: 1,
        page_type_id: 9102
    }
};
/**
 * Occurs only once on action 'visit' on the Activity Details Page
 */
exports.ActivitiesDetailsPageDesktopVisitEventManifestV1 = {
    ids: {
        action_type: 'visit',
        event_version: 1,
        page_type_id: 9102
    }
};
